import { createRouter, createWebHistory } from "vue-router";
import ResetPasswordPage from "../pages/Authentication/ResetPasswordPage.vue";
import SignInPage from "../pages/Authentication/SignInPage.vue";
import ForgotPasswordPage from "../pages/Authentication/ForgotPasswordPage.vue";
import CompanySetupPage from "@/pages/Authentication/CompanySetupPage.vue";
import RHDigitalMuralPage from "@/pages/RHDigital/MuralPage.vue";
import RHDigitalDepartmentsListPage from "@/pages/RHDigital/DepartmentsListPage.vue";
import RHDigitalSectorsListPage from "@/pages/RHDigital/SectorsListPage.vue";
import RHDigitalTeamsListPage from "@/pages/RHDigital/TeamsListPage.vue";
import RHDigitalHRManagementPage from "@/pages/RHDigital/HRManagement/Index.vue";
import RHDigitalCollaboratorsListPage from "@/pages/RHDigital/HRManagement/CollaboratorsListPage.vue";
import RHDigitalCollaboratorPage from "@/pages/RHDigital/HRManagement/CollaboratorPage.vue";
import NotFoundPage from "../pages/Error/ErrorPage.vue";
import HomePage from "@/pages/Home/Index.vue";
import SsoPage from "@/pages/Sso/SsoPage.vue";
import {hasSession, logout, refreshToken, tokenNeedsRefresh} from "@/services/api/auth"
import { limparSessao } from "@/services/limparSessao.js"
import { convitePendente, esquecerConvitePendente, guardarConvitePendente } from "@/services/convitePendente.js"
import { decidirNavegacao, ehPublica } from "@/services/decisaoDeRota.js"
import MyProfilePage from "../pages/Account/MyProfilePage.vue";
import ChangePasswordPage from "@/pages/Account/ChangePasswordPage.vue";
import DashboardContractsPage from "@/pages/Dashboard/Contracts.vue";
import ListContractsPage from "@/pages/Contracts/ContractsListPage.vue";
import CorporationSelectionPage from "@/pages/Settings/CorporationSelectionPage.vue"
import SettingsPage from "@/pages/Settings/Index.vue"
import UsersListPage from "@/pages/Users/UsersListPage.vue";
import TwoFactorPage from "@/pages/Authentication/TwoFactorPage.vue";
import { PublicPages } from '@/enums/enums.js'
// Fecha ciclo de import -- apps.js puxa o apiClient, que puxa o auth, que
// importa este router. E inocuo porque o auth so usa `router` dentro de uma
// funcao (`router.push('/')`), nunca na avaliacao do modulo: quando aquela
// linha roda, este arquivo ja terminou de ser avaliado. Se um dia o auth
// passar a usar o router no topo, este import precisa virar `await import()`
// dentro do guard.
import { retomarPedidoDeVolta } from '@/services/api/apps.js'
import UserPage from "@/pages/Users/UserPage.vue";
import PermissionManagementListPage from "@/pages/Settings/PermissionManagementListPage.vue";
import PermissionManagementPage from "@/pages/Settings/PermissionManagementPage.vue"
import ApplicationsListPage from "@/pages/Settings/ApplicationsListPage.vue"
import ApplicationPage from "@/pages/Settings/ApplicationPage.vue"
import ISPPage from "@/pages/ISP/Index.vue"
import ManufacturerListPage from "@/pages/ISP/ManufacturerListPage.vue"
import ManufacturerPage from "@/pages/ISP/ManufacturerPage.vue"
import AttributeListPage from "../pages/ISP/AttributeListPage.vue";
import AttributePage from "../pages/ISP/AttributePage.vue";
import LayoutListPage from "../pages/ISP/LayoutListPage.vue";
import LayoutPage from "../pages/ISP/LayoutPage.vue";
import POPPage from "../pages/POP/POPPage.vue";
import POPListPage from "@/pages/POP/POPListPage.vue";
import PoolPage from "../pages/ISP/PoolPage.vue";
import PoolListPage from "@/pages/ISP/PoolListPage.vue";
import ConcentratorPage from "../pages/ISP/ConcentratorPage.vue";
import ConcentratorListPage from "@/pages/ISP/ConcentratorListPage.vue";
import ContractPage from "@/pages/Contracts/ContractPage.vue";
import ContractIndexPage from "../pages/Contracts/Index.vue";
import ProductPage from "../pages/Products/ProductPage.vue";
import ProductListPage from "../pages/Products/ProductListPage.vue";
import ConnectionListPage from "@/pages/Contracts/ConnectionsListPage.vue";
import ConnectionPage from "@/pages/Contracts/ConnectionPage.vue";
import ManageFavoritesPage from "@/pages/Common/ManageFavoritesPage.vue";
import DisplayPage from "@/pages/Assistance/DisplayPage.vue";
import KioskPage from "@/pages/Assistance/KioskPage.vue";
import ChoosePage from "@/pages/Assistance/ChoosePage.vue";
import ServiceTypesPage from "@/pages/ServiceTypes/ServiceTypesPage.vue"
import ServiceTypesListPage from "@/pages/ServiceTypes/ServiceTypesListPage.vue"
import IXCCustomerListPage from "@/pages/IXC/IXCCustomerListPage.vue"
import IXCCustomerPage from "@/pages/IXC/IXCCustomerPage.vue"
import CallPanelPage from "@/pages/Assistance/CallPanelPage.vue";
import QrcodeIndexPage from "@/pages/QRCode/Index.vue";
import QrcodeCategoriesListPage from "@/pages/QRCode/CategoriesListPage.vue";
import QrcodeCategoriesPage from "@/pages/QRCode/CategoriesPage.vue";
import QrcodeCampaignsListPage from "@/pages/QRCode/CampaignsListPage.vue";
import QrcodeCampaignsPage from "@/pages/QRCode/CampaignsPage.vue";
import QrcodeURLsListPage from "@/pages/QRCode/URLsListPage.vue";
import QrcodeURLsPage from "@/pages/QRCode/URLsPage.vue";
import QrcodeLogosListPage from "@/pages/QRCode/LogosListPage.vue";
import QrcodeLogosPage from "@/pages/QRCode/LogosPage.vue";

const routes = [
    {
        path: "/reset-password",
        name: "reset-password",
        component: ResetPasswordPage,
        props: true,
    },
    {
        path: "/",
        name: "sign-in",
        component: SignInPage,
    },
    {
        // Unica rota que o admin RECEBE em vez de emitir -- ver
        // pages/Sso/SsoPage.vue. `meta.publica` faz o guard deixar passar
        // tanto sem sessao (chegada normal) quanto com uma sessao antiga ja
        // aberta (a pessoa estava logada e personifica em cima): sem isto o
        // guard mandaria para /home antes da pagina trocar o ticket.
        path: "/sso",
        name: "sso",
        component: SsoPage,
        meta: { publica: true },
    },
    {
        path: "/rhdigital",
        name: "sign-in-rhdigital",
        component: SignInPage,
    },
    {
        path: '/logout',
        name: 'Logout',
        beforeEnter: async (to, from, next) => {
            // `logout()` pode nunca resolver nem rejeitar: se a sessao ja
            // estiver revogada, o apiClient devolve uma promise pendurada de
            // proposito (quem chama ali normalmente esta saindo da pagina de
            // qualquer jeito). Aqui quem aguarda e este guard de rota dentro da
            // SPA -- sem um limite de tempo, a navegacao trava para sempre e a
            // tela fica em branco em cima da rota anterior, que nunca chega a
            // sair. O `Promise.race` garante que a navegacao sempre conclui.
            try {
                await Promise.race([
                    logout(),
                    new Promise((resolve) => setTimeout(resolve, 3000)),
                ]);
            } catch (error) {
                console.error(error);
            } finally {
                // `hasSession()` confere so o localStorage, entao isto basta
                // para o guard global tratar a pessoa como deslogada mesmo
                // que `logout()` ainda nao tenha terminado (ou nunca termine).
                limparSessao();
                next('/');
            }
        }
    },
    {
        path: "/forgot-password",
        name: "forgot-password",
        component: ForgotPasswordPage,

    },
    {
        path: "/company-setup",
        name: "company-setup",
        component: CompanySetupPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/rhdigital/company-setup",
        name: "rhdigital-company-setup",
        component: CompanySetupPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/rhdigital/corporation-selection",
        name: "rhdigital-corporation-selection",
        component: CorporationSelectionPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/rhdigital/mural",
        name: "rhdigital-mural",
        component: RHDigitalMuralPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/rhdigital/departments",
        name: "rhdigital-departments",
        component: RHDigitalDepartmentsListPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/rhdigital/sectors",
        name: "rhdigital-sectors",
        component: RHDigitalSectorsListPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/rhdigital/teams",
        name: "rhdigital-teams",
        component: RHDigitalTeamsListPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/rhdigital/hr-management",
        name: "rhdigital-hr-management",
        component: RHDigitalHRManagementPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/rhdigital/hr-management/collaborators",
        name: "rhdigital-collaborators",
        component: RHDigitalCollaboratorsListPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/rhdigital/hr-management/collaborator/create",
        name: "rhdigital-collaborator-create",
        component: RHDigitalCollaboratorPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/rhdigital/hr-management/collaborator/edit/:id",
        name: "rhdigital-collaborator-edit",
        component: RHDigitalCollaboratorPage,
        props: true,
        meta: { requiresAuth: true }
    },
    {
        path: "/rhdigital/settings",
        name: "rhdigital-settings",
        component: SettingsPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/rhdigital/settings/users",
        name: "rhdigital-settings-users",
        component: UsersListPage,
        props: true,
        meta: { requiresAuth: true }
    },
    {
        path: "/rhdigital/settings/user/create",
        name: "rhdigital-user-create",
        component: UserPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/rhdigital/settings/user/edit/:id",
        name: "rhdigital-user-edit",
        component: UserPage,
        props: true,
        meta: { requiresAuth: true }
    },
    {
        path: "/rhdigital/settings/permission-management",
        name: "rhdigital-settings-permission-management",
        component: PermissionManagementListPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/rhdigital/settings/permission-management/create",
        name: "rhdigital-settings-permission-management-create",
        component: PermissionManagementPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/rhdigital/settings/permission-management/edit/:id",
        name: "rhdigital-permission-management-edit",
        component: PermissionManagementPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/rhdigital/settings/corporation-selection",
        name: "rhdigital-settings-corporation-selection",
        component: CorporationSelectionPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/home",
        name: "home",
        component: HomePage,
        meta: { requiresAuth: true }
    },
    {
        path: "/my-profile",
        name: "my-profile",
        component: MyProfilePage,
        meta: { requiresAuth: true }
    },
    {
        path: "/my-profile/change-password",
        name: "my-profile/change-password",
        component: ChangePasswordPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/dashboard/contracts",
        name: "/dashboard/contracts",
        component: DashboardContractsPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/contracts",
        name: "/contracts",
        component: ContractIndexPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/contracts/contract-list",
        name: "/contracts/contract-list",
        component: ListContractsPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/contracts/view/:id",
        name: "contract-view",
        component: ContractPage,
    },
    {
        path: "/products",
        name: "/products",
        component: ProductListPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/products/view/:id",
        name: "/product-view",
        component: ProductPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/contracts/connections",
        name: "/contracts/connections",
        component: ConnectionListPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/contracts/connections/view/:id",
        name: "/connection-view",
        component: ConnectionPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/corporation-selection",
        name: "corporation-selection",
        component: CorporationSelectionPage,
        meta: { requiresAuth: true }
    },

    {
        path: "/settings/users",
        name: "settings-users",
        component: UsersListPage,
        props: true,
    },
    {
        path: "/settings/user/create",
        name: "user-create",
        component: UserPage,
    },
    {
        path: "/settings/user/edit/:id",
        name: "user-edit",
        component: UserPage,
        props: true,
    },

    {
        path: "/settings",
        name: "settings",
        component: SettingsPage,
        meta: {requiresAuth: true},
    },
    {
        // Registry de aplicacoes: e daqui que sai o menu de aplicacoes e o
        // destino do ticket de SSO.
        path: "/settings/applications",
        name: "settings-applications",
        component: ApplicationsListPage,
        meta: { requiresAuth: true },
    },
    {
        path: "/settings/applications/create",
        name: "settings-applications-create",
        component: ApplicationPage,
        meta: { requiresAuth: true },
    },
    {
        path: "/settings/applications/edit/:id",
        name: "settings-applications-edit",
        component: ApplicationPage,
        props: true,
        meta: { requiresAuth: true },
    },
    {
        path: "/settings/permission-management",
        name: "settings-permission-management",
        component: PermissionManagementListPage,
        eta: { requiresAuth: true }
    },
    {
        path: "/settings/permission-management/create",
        name: "/settings/permission-management-create",
        component: PermissionManagementPage,
        eta: { requiresAuth: true }
    },
    {
        path: "/settings/permission-management/edit/:id",
        name: "permission-management-edit",
        component: PermissionManagementPage,
        eta: { requiresAuth: true }
    },
    {
        path: "/users",
        name: "/users",
        component: UsersListPage,
        meta: { requiresAuth: true }
    },
    {
        path: "/two-factor",
        name: "/two-factor",
        component: TwoFactorPage,
    },
    {
        path: "/isp/pop/create",
        name: "pop",
        component: POPPage,
    },
    {
        path: "/isp/pops",
        name: "pops",
        component: POPListPage,
    },
    {
        path: "/isp/pop/edit/:id",
        name: "pop-edit",
        component: POPPage,
    },
    {
        path: "/isp/layouts",
        name: "layout",
        component: LayoutListPage,
        props: true,
    },
    {
        path: "/isp/layout/edit/:id",
        name: "layout-edit",
        component: LayoutPage,
        props: true,
    },
    {
        path: "/isp/layout/create",
        name: "layout-create",
        component: LayoutPage,
        props: true,
    },
    {
        path: "/isp/attribute",
        name: "attribute",
        component: AttributeListPage,
        props: true,
    },
    {
        path: "/isp/attribute/create",
        name: "attribute-create",
        component: AttributePage,
        props: true,
    },
    {
        path: "/isp/attribute/edit/:id",
        name: "attribute-edit",
        component: AttributePage,
        props: true,
    },

    {
        path: "/isp/pools",
        name: "pool",
        component:PoolListPage,
        props: true,
    },
    {
        path: "/isp/pool/create",
        name: "pool-create",
        component:PoolPage,
        props: true,
    },
    {
        path: "/isp/pool/edit/:id",
        name: "pool-edit",
        component:PoolPage,
        props: true,
    },

    {
        path: "/isp/concentrators",
        name: "concentrator",
        component:ConcentratorListPage,
        props: true,
    },
    {
        path: "/isp/concentrator/create",
        name: "concentrator-create",
        component:ConcentratorPage,
        props: true,
    },
    {
        path: "/isp/concentrator/edit/:id",
        name: "concentrator-edit",
        component:ConcentratorPage,
        props: true,
    },
    {
        path: "/isp/manufacturer",
        name: "manufacturer",
        component: ManufacturerListPage,
        props: true,
    },
    {
        path: "/isp/manufacturer/create",
        name: "manufacturer-create",
        component: ManufacturerPage,
        props: true,
    },
    {
        path: "/isp/manufacturer/edit/:id",
        name: "manufacturer-edit",
        component: ManufacturerPage,
        props: true,
    },
    {
        path: "/isp",
        name: "isp",
        component: ISPPage,
        meta: { requiresAuth: true },
    },
    {
        path: "/manageFavorites",
        name: "manageFavorites",
        component: ManageFavoritesPage,
        meta: { requiresAuth: true },
    },
    {
        path: "/display",
        name: "/display",
        component: DisplayPage,
    },
    {
        path: "/kiosk",
        name: "/kiosk",
        component: KioskPage,
        meta: { layout: 'blank' }
    },
    {
        path: "/call-panel",
        name: "/call-panel",
        component: CallPanelPage,
        meta: { layout: 'blank' }
    },
    {
        path: "/choose",
        name: "/choose",
        component: ChoosePage,
    },
    {
        path: "/service-types",
        name: "service-types",
        component: ServiceTypesListPage,
        meta: { requiresAuth: true },
    },
    {
        path: "/service-types/create",
        name: "service-types-create",
        component: ServiceTypesPage,
        meta: { requiresAuth: true },
    },
    {
        path: "/service-types/edit/:id",
        name: "service-types-edit",
        component: ServiceTypesPage,
        meta: { requiresAuth: true },
    },
    {
        path: "/ixc/customers/view/:id",
        name: "person-view",
        component: IXCCustomerPage,
        meta: { requiresAuth: true },
    },
    {
        path: "/ixc/customers",
        name: "customers",
        component: IXCCustomerListPage,
        meta: { requiresAuth: true },
    },
    {
        path: "/qrcode",
        name: "qrcode",
        component: QrcodeIndexPage,
        meta: { requiresAuth: true },
    },
    { path: "/qrcode/categories", name: "qrcode-categories", component: QrcodeCategoriesListPage, meta: { requiresAuth: true } },
    { path: "/qrcode/categories/create", name: "qrcode-categories-create", component: QrcodeCategoriesPage, meta: { requiresAuth: true } },
    { path: "/qrcode/categories/edit/:id", name: "qrcode-categories-edit", component: QrcodeCategoriesPage, meta: { requiresAuth: true } },

    { path: "/qrcode/campaigns", name: "qrcode-campaigns", component: QrcodeCampaignsListPage, meta: { requiresAuth: true } },
    { path: "/qrcode/campaigns/create", name: "qrcode-campaigns-create", component: QrcodeCampaignsPage, meta: { requiresAuth: true } },
    { path: "/qrcode/campaigns/edit/:id", name: "qrcode-campaigns-edit", component: QrcodeCampaignsPage, meta: { requiresAuth: true } },

    { path: "/qrcode/urls", name: "qrcode-urls", component: QrcodeURLsListPage, meta: { requiresAuth: true } },
    { path: "/qrcode/urls/create", name: "qrcode-urls-create", component: QrcodeURLsPage, meta: { requiresAuth: true } },
    { path: "/qrcode/urls/edit/:id", name: "qrcode-urls-edit", component: QrcodeURLsPage, meta: { requiresAuth: true } },

    { path: "/qrcode/logos", name: "qrcode-logos", component: QrcodeLogosListPage, meta: { requiresAuth: true } },
    { path: "/qrcode/logos/create", name: "qrcode-logos-create", component: QrcodeLogosPage, meta: { requiresAuth: true } },
    { path: "/qrcode/logos/edit/:id", name: "qrcode-logos-edit", component: QrcodeLogosPage, meta: { requiresAuth: true } },
    {
        // O token vai na URL, entao esta rota nao cabe em `PublicPages`, que
        // compara caminhos exatos. `meta.publica` cobre esse caso.
        path: "/invitation/:token",
        name: "invitation",
        component: () => import("@/pages/Invitation/InvitationPage.vue"),
        meta: { publica: true },
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: NotFoundPage,
    }

];

const router = createRouter({
    history: createWebHistory(),
    routes,
    linkExactActiveClass: "active",
    scrollBehavior() {
        return { top: 0, behavior: "smooth" };
    },
});



router.beforeEach(async (to, from, next) => {
    const hasAuth = hasSession();

    // A renovacao vem antes da decisao porque so ela pode derrubar a sessao no
    // meio do caminho. O "sem sessao em tela protegida" nao se perde nisso:
    // este bloco so roda com sessao.
    if (hasAuth && tokenNeedsRefresh()) {
        try {
            await refreshToken();
        } catch {
            // Sessao velha demais para renovar. Se o que a pessoa abriu foi um
            // convite, o desvio para o login apagaria justamente o que ela veio
            // fazer -- guarda antes de sair.
            if (to.name === 'invitation' && to.params?.token) {
                guardarConvitePendente(to.params.token);
            }

            return next('/');
        }
    }

    // A decisao mora em `decisaoDeRota.js` para poder ser testada: aqui dentro
    // ela seria inalcancavel, porque este arquivo importa todas as paginas.
    const decisao = decidirNavegacao({
        temSessao: hasAuth,
        caminho: to.path,
        meta: to.meta,
        publicas: PublicPages,
        nomeDaRota: to.name,
        pendente: convitePendente(),
    });

    if (decisao.acao === 'login') {
        return next('/');
    }

    if (decisao.acao === 'home') {
        return next('/home');
    }

    if (decisao.acao === 'desviar') {
        // Consome agora: se o convite ja tiver sido usado ou o link for
        // invalido, a tela mostra o motivo uma vez e nao prende ninguem num
        // desvio que se repete a cada navegacao.
        esquecerConvitePendente();
        return next(decisao.destino);
    }

    if (to.matched.length === 0) {
        return next({ name: 'not-found' });
    }

    // Sessao pronta e fora das telas de autenticacao: se alguma aplicacao pediu
    // o login, a pessoa volta para ela agora. E aqui, e nao no fim do
    // SignIn.vue, porque o login termina em lugares diferentes -- home,
    // escolha de empresa, segundo fator, kiosk -- e todos desaguam numa
    // navegacao autenticada.
    if (hasAuth && !ehPublica(to.path, to.meta, PublicPages)) {
        const voltou = await retomarPedidoDeVolta();

        if (voltou) {
            // A pagina esta indo para outra origem: aborta a navegacao, para a
            // tela nao piscar a home no caminho. `next(false)` e nao `return
            // false` porque este guard declara o terceiro argumento -- o Vue
            // Router ignora o retorno de quem recebe `next`.
            return next(false);
        }
    }

    next();
});


export default router;
